import { Item } from "@/lib/api/products";
import { RecommendationScore } from "./ruleBased";

/**
 * AI 기반 추천 (향후 확장용)
 * 
 * TODO: AI Embedding 기반 추천 구현
 * - OpenAI Embedding API
 * - Pinecone 벡터 검색
 * - 사용자 행동 기반 협업 필터링
 * - 딥러닝 모델 통합
 */
export async function aiBasedRecommendation(
  currentItem: Item,
  candidateItems: Item[],
  userContext?: {
    userId?: string;
    viewedItems?: string[];
    likedItems?: string[];
    purchaseHistory?: string[];
  }
): Promise<RecommendationScore[]> {
  // TODO: AI 추천 로직 구현
  // 예시:
  // 1. 현재 상품의 Embedding 벡터 생성
  // 2. 후보 상품들의 Embedding 벡터와 유사도 계산
  // 3. 사용자 행동 데이터 기반 가중치 적용
  // 4. 점수 정규화 및 정렬

  // 현재는 빈 배열 반환 (구현 전까지)
  console.warn("AI 추천 기능은 아직 구현되지 않았습니다. 룰베이스 추천을 사용하세요.");
  
  return candidateItems.map((item) => ({
    item,
    score: 0,
    reasons: ["AI 추천 (구현 예정)"],
  }));
}

/**
 * 하이브리드 추천 (룰베이스 + AI)
 * 룰베이스와 AI 추천을 결합하여 최종 추천 생성
 */
export async function hybridRecommendation(
  currentItem: Item,
  candidateItems: Item[],
  userContext?: {
    userId?: string;
    viewedItems?: string[];
    likedItems?: string[];
    purchaseHistory?: string[];
  },
  weights: { ruleBased: number; ai: number } = { ruleBased: 0.7, ai: 0.3 }
): Promise<RecommendationScore[]> {
  // TODO: 룰베이스와 AI 추천을 가중 평균하여 결합
  // 현재는 룰베이스만 사용
  const { ruleBasedRecommendation } = await import("./ruleBased");
  return ruleBasedRecommendation(currentItem, candidateItems);
}

